import React from 'react';
import { Loader } from '../Loader';
import { useAirtableAnnouncement } from '../hooks/useAirtableAnnouncement';

interface FieldProps {
  title: string;
  description: string;
}

export const Announcements = (): React.ReactElement => {
  const [announcements, isLoading] = useAirtableAnnouncement();

  if (isLoading) return <Loader />

  return (
    <div className='container mx-auto md:w-2/3 h-screen mb-14 border-2 border-b-0'>
      {announcements.map(({ fields }: { fields: FieldProps }) => {
        return (
          <div
            key={fields.title}
            className='
              flex flex-row gap-4 md:gap-0
              items-center justify-between
              p-4 border-b-2'
          >
            <div className='flex w-full gap-2'>
              <p className='text-4xl md:text-base'>{fields.title}</p>

            </div>

            <div className='flex items-center gap-2'>
              {fields.description}
            </div>
          </div>
        );
      })}
    </div>
  );
};
